import React from 'react';
import NavigationCard, { NavigationCardProps } from 'src/components/homepage/NavigationCard';
import { useAppSelector } from 'src/redux/hooks';
import { AppState } from 'src/redux/store';
import { FAQS, GUIDELINES, RELEASE_NOTES } from 'src/constants/pages';
import { getMpNameFromId, useTranslation } from 'src/utils';
import { Marketplaces } from 'src/types/Marketplaces';
import { NavigationCardTypes } from 'src/constants/metrics';
import { communityLinks } from 'src/constants/communityGuidelines';

const Tools = () => {
  const { t } = useTranslation();
  /**
   * @todo add the links once product team provides links
   * sims- https://sim.amazon.com/issues/SPCE-2681, https://sim.amazon.com/issues/SPCE-2682, https://sim.amazon.com/issues/SPCE-2683
   */

  const marketplaceId = useAppSelector(
    ({ userInfo }: AppState) => userInfo.selectedMarketplaceId,
  );
  const reportAbuseLink = '/abuse-submission/index.html';
  const marketplaceName = getMpNameFromId(marketplaceId) || Marketplaces.usa;

  const tools: Array<NavigationCardProps> = [
    {
      title: t('homePage_tools_faqHeader'),
      description: t('homePage_tools_faqDescription'),
      linkHref: FAQS,
      linkText: t('homePage_tools_faqLinkText'),
      metricValue: NavigationCardTypes.faq,
    },
    {
      title: t('homePage_tools_guidelinesHeader'),
      description: t('homePage_tools_guidelinesDescription'),
      linkHref: GUIDELINES,
      linkText: t('homePage_tools_guidelinesLinkText'),
      metricValue: NavigationCardTypes.guidelines,
    },
    {
      title: t('homePage_tools_termsHeader'),
      description: t('homePage_tools_termsDescription'),
      linkHref: communityLinks[marketplaceName].conditionsOfUse,
      linkText: t('homePage_tools_termsLinkText'),
      metricValue: NavigationCardTypes.termsOfUse,
    },
    {
      title: t('homePage_tools_privacyHeader'),
      description: t('homePage_tools_privacyDescription'),
      linkHref: communityLinks[marketplaceName!].privacyNotice,
      linkText: t('homePage_tools_privacyLinkText'),
      metricValue: NavigationCardTypes.privacyNotice,
    },
    {
      title: t('homePage_tools_reportAbuseHeader'),
      description: t('homePage_tools_reportAbuseDescription'),
      linkHref: reportAbuseLink,
      linkText: t('homePage_tools_reportAbuseLinkText'),
      metricValue: NavigationCardTypes.reportAbuse,
      katLink: true,
    },
    {
      title: t('homePage_tools_releaseNotesHeader'),
      description: t('homePage_tools_releaseNotesDescription'),
      linkHref: RELEASE_NOTES,
      linkText: t('homePage_tools_releaseNotesLinkText'),
      metricValue: NavigationCardTypes.releaseNotes,
    },
  ];

  return (
    <div data-testid="tools" className="container mt-8 mb-22">
      <div className="kat-col-lg-8 kat-offset-lg-2">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {tools.map((tool) => <NavigationCard newTab key={tool.title} {...tool} />)}
        </div>
      </div>
    </div>
  );
};

export default Tools;
